export default "__VITE_ASSET__BQGBM$vi__"